var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Change Your Password"),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "rb-input",
            {
              attrs: {
                "for-id": "newPassword",
                error: _vm.$showError("newPassword"),
              },
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Enter New Password"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.password,
                    expression: "data.password",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: true,
                      max: 200,
                      min: 8,
                      has_lowercase: true,
                      has_uppercase: true,
                      has_number: true,
                      no_whitespace: true,
                    },
                    expression:
                      "{required: true, max: 200, min: 8, has_lowercase: true, has_uppercase: true, has_number: true, no_whitespace: true}",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "newPassword",
                  type: "password",
                  name: "newPassword",
                  "data-vv-as": "Password",
                },
                domProps: { value: _vm.data.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data, "password", $event.target.value)
                  },
                },
              }),
            ]
          ),
          _c(
            "rb-input",
            {
              attrs: {
                "for-id": "confirmPassword",
                error: _vm.$showError("confirmPassword"),
              },
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Confirm New Password"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.confirmPassword,
                    expression: "data.confirmPassword",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true, value: _vm.data.password },
                    expression: "{ required: true, value: data.password }",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "confirmPassword",
                  type: "password",
                  name: "confirmPassword",
                  "data-vv-as": "Confirm Password",
                },
                domProps: { value: _vm.data.confirmPassword },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data, "confirmPassword", $event.target.value)
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }